import React, { useState } from 'react';
import { translate } from "../Services/translation";

const FacetedSearchCompact = ({facetFilters, visibleDropdownMenu, toggleVisibleDropdownMenu, onFacetChange, onSubmit}) => {
    const [hidden, setHidden] = useState(true)

    const onClick = () => {
        setHidden(!hidden);
    }

    return (
        <ul className="faceted-search faceted-search--compact" >
            {facetFilters && facetFilters.map((group, groupIndex, array) => group.options && group.options.length > 0 && (
                <li className={`faceted-search__group ${groupIndex > 2 && hidden ? "faceted-search__group--hidden" : ""}`} key={`${group.label}-${groupIndex}`}>
                    <div className={`faceted-search__group-header ${visibleDropdownMenu.includes(group.id)? 'faceted-search__group-header--show-compact':''}`} role="faceted-search-item-group" onClick={event => toggleVisibleDropdownMenu(group)}>
                        { group.label }
                    </div>
                    <div className="faceted-search__sublist-wrapper">
                        <ul className="faceted-search__sublist">
                            {group.options && group.options.map((item, itemIndex, array) => (
                                <li key={`${item.label}-${itemIndex}`} className="faceted-search__item" role="faceted-search-item">
                                    <FacetedFilterCheckbox item={item} group={group} onFacetChange={onFacetChange}/>
                                </li>
                            ))}
                        </ul>
                        <button className="filter__button" onClick={event => {toggleVisibleDropdownMenu(group);onSubmit(facetFilters)}}>{translate('general.select')}</button>
                    </div>
                </li>
            ))}
            {facetFilters && facetFilters.length > 3 &&<a className='faceted-search__show-more-btn' onClick={onClick}>{translate(hidden ? "category-navigation.show-filters" : "category-navigation.hide-filters")}</a>}
        </ul>
    );
};

const FacetedFilterCheckbox = ({item, group, onFacetChange}) => (
    <label className="faceted-filter" >
        <input className="faceted-filter__input" type="checkbox" onChange={event => onFacetChange(group, item)} checked={group.selectedOptions.includes(item.id)} />
        <span className="faceted-filter__label">
            {item.label}
            {!isNaN(item.quantity) && item.quantity > 0 &&
                <span className="faceted-filter__quantity"> ({item.quantity})</span>
            }
        </span>
    </label>
)

export default FacetedSearchCompact;
